import React from "react";
import { Helmet } from "react-helmet";


const AkSanadehadees = () => {
  return (
    <>
      <Helmet>
        <title>سند حدیث - Khanqah Imdadia Ashrafia</title>
        <meta name="description" content="dummy text" />
      </Helmet>
      <div class="pageTitle">
        <h1>
          شیخ العرب والعجم عارف باللہ مجددزمانہ حضرت اقدس مولاناشاہ حکیم محمد
          اخترصاحب رحمۃ اللہ علیہ
        </h1>
      </div>
      <div className="container textPages">
        <div className="row">
          <div className="col-md-12">
            <div>
              <h1>سَنَدُ اِجَازَتِ الْحَدِیْث</h1>
              <p>
                سماحۃ الشیخ العالم الربانی العارف الحکیم محمد اختر رحمۃ اللہ
                علیہ <br></br>
                عن الشیخ عبد الغنی الفورفوری رحمۃ اللہ علیہ <br></br>
                عن الشیخ ماجد علی الجونفوری رحمۃ اللہ علیہ <br></br>
                عن قطب العالم الشیخ رشید احمد الجنجوحی رحمۃ اللہ علیہ <br></br>
                عن الشیخ عبد الغنی المجددی الدھلوی رحمۃ اللہ علیہ <br></br>
                عن الشیخ أبی سعید الدھلوی المدنی رحمۃ اللہ علیہ <br></br>
                عن الشیخ محمد اسحٰق الدھلوی رحمۃ اللہ علیہ <br></br>
                عن الشیخ عبد العزیز الدھلوی رحمۃ اللہ علیہ <br></br>
                عن الشیخ الامام ولی اللہ الدھلوی رحمہم اللہ تعالیٰ <br></br>
                عن الشیخ ابو طاہر محمد بن ابراہیم رحمۃ اللہ علیہ <br></br>
                عن الشیخ ابراہیم بن حسن کردی رحمۃ اللہ علیہ <br></br>
                عن الشیخ احمد بن محمد قشاشی رحمۃ اللہ علیہ <br></br>
                عن الشیخ احمد بن عبد القدوس شناوی رحمۃ اللہ علیہ <br></br>
                عن الشیخ شمس الدین محمد بن احمد رملی رحمۃ اللہ علیہ <br></br>
                عن الشیخ زین الدین زکریا بن محمد انصاری رحمۃ اللہ علیہ <br></br>
                عن الشیخ شہاب الدین احمد علی بن حجر عسقلانی رحمۃ اللہ علیہ{" "}
                <br></br>
                عن الشیخ ابراہیم بن احمد تنوخی رحمۃ اللہ علیہ <br></br>
                عن الشیخ ابو العباس احمد بن ابی طالب حجاز رحمۃ اللہ علیہ{" "}
                <br></br>
                عن الشیخ حسین بن مبارک زیدی رحمۃ اللہ علیہ <br></br>
                عن الشیخ عبد الاول بن عیسیٰ ہروی رحمۃ اللہ علیہ <br></br>
                عن الشیخ عبد الرحمن بن مظفر داؤدی رحمۃ اللہ علیہ <br></br>
                عن الشیخ محمد عبد اللہ بن احمد السرخسی رحمۃ اللہ علیہ <br></br>
                عن الشیخ ابو عبد اللہ محمد بن یوسف فربری رحمۃ اللہ علیہ{" "}
                <br></br>
                عن الشیخ ابو عبد اللہ محمد بن اسماعیل بخاری رحمۃ اللہ علیہ{" "}
                <br></br>
                عن الشیخ امام عصام بن خالد رحمۃ اللہ علیہ <br></br>
                عن الشیخ امام حریز بن عثمان رحمۃ اللہ علیہ <br></br>
                عن الشیخ سیدنا عبد اللہ بن بسر رضی اللہ عنہ <br></br>
                عن الشیخ سیدنا سلمہ بن الاکوع رضی اللہ عنہ <br></br>
                عن سیدنا ونبینا و هادینا محمد صلی اللہ علیہ وسلم
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AkSanadehadees;
